/**
 * Normalizes a contact search query for dedupe / in-flight checks.
 * Phone-like input collapses to digits so formatting variants share a key.
 */
export function normalizeSearchKey(query: string): string {
  const trimmed = query.trim();
  const digits = trimmed.replace(/\D/g, '');

  if (digits.length >= 7 && /^[\d\s+().-]+$/.test(trimmed)) {
    return digits;
  }

  return trimmed.toLowerCase();
}
